// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import DynamicFormModel from '../../model/dynamic-form-model';
import DynamicFormDTO from '../dto/dynamic-form-dto';
import dtoSchema from '../schemas/dynamic-form-schema';
import ResourceLinkModel from '../../model/resource-link-model';
import DynamicFormFieldModel from '../../model/dynamic-form-field-model';

export default abstract class DynamicFormModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<DynamicFormDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.description = data.description ?? undefined;
      this.formFields = data.formFields?.map((i) => DynamicFormFieldModel.toModel(i)) ?? [];
    }
  }
  /**
  * @type {uuid}
  */
  id?: string;
  /**
  */
  links?: ResourceLinkModel[];
  /**
  */
  description?: string;
  /**
  */
  formFields?: DynamicFormFieldModel[];

  static toModel(dto: DeepPartial<DynamicFormDTO>): DynamicFormModel;
  static toModel(dto: DeepPartial<DynamicFormDTO> | undefined | null): DynamicFormModel | undefined;
  static toModel(dto: DeepPartial<DynamicFormDTO> | undefined | null): DynamicFormModel | undefined {
    return dto ? new DynamicFormModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<DynamicFormModel> | DynamicFormModel): DynamicFormDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
      links: unwrapped.links,
      description: unwrapped.description,
      formFields: unwrapped.formFields,
    } as DynamicFormDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for DynamicFormModel, can not map to DynamicFormDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
